import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import emissionViewStore from "../../Store/marco/emissionViewStore";
import commonStore from "../../Store/marco/commonStore";
import { getConstByStandard } from "../utils/getConstFileByStandard";
import dayjs from "dayjs";
// import { Pagination } from "./Pagination";
import { checkEmissionUnitType } from "../components/utils/checkEmissionUnitType";
//mui-icons
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
//mui
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  Stack,
} from "@mui/material";

//css
import styles from "../styles/emission.module.css";

//api
import { emissionAPI } from "../API/emissionAPI";

//翻譯
import { useTranslation } from "react-i18next";

//accordionTitles
const activityAccordionTitles = [
  "",
  "No.",
  "Entity Name",
  "Name",
  "Total Emission",
  "Unit",
];

const activityAccordionTitles1_4 = [
  //多一個GWP
  "",
  "No.",
  "Entity Name",
  "Name",
  "HCFs GWP",
  "Total Emission",
  "Unit",
];

//fileTableTitles
const fileTableTitles = [
  "Used Date",
  "CO₂",
  "CH₄",
  "N₂O",
  "HFCs",
  "PFCs",
  "NF₃",
  "SF₆",
  "Total",
];
const fileTableTitles2_1 = [
  "Used Date",
  "Data",
  "CO₂",
  "CH₄",
  "N₂O",
  "HFCs",
  "PFCs",
  "NF₃",
  "SF₆",
  "Total",
];

//ActivityAccordion
const ActivityAccordion = ({
  index,
  displayNumber,
  device,
  expanded,
  onExpand,
}) => {
  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const category = CONST.category;
  const cat = category[emissionViewStore.selectedTab].substring(3);
  return (
    <Accordion expanded={!!expanded} onChange={onExpand}>
      <AccordionSummary sx={{ padding: "8px 0px" }}>
        <Box
          display="grid"
          // gridTemplateColumns="0.2fr 0.3fr repeat(4, 1fr)"
          gridTemplateColumns={
            cat === "1_4"
              ? "0.2fr 0.3fr 1.2fr repeat(4, 1fr)" // 7 欄
              : "0.2fr 0.3fr 1.2fr repeat(3, 1fr)" // 6 欄
          }
          width="100%"
          alignItems="center"
          sx={{
            textAlign: "center",
          }}
        >
          <ExpandMoreIcon
            color="primary"
            className={`transform transition-transform ${
              expanded ? "rotate-180" : "rotate-0"
            }`}
            sx={{ justifySelf: "center" }}
          />
          <ActivityInfo device={device} index={displayNumber} />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <FilesData
          fileData={device.emissionUnitList}
          dataTypeId={device.dataTypeId}
        />
      </AccordionDetails>
    </Accordion>
  );
};

//ActivityInfo
const ActivityInfo = observer(({ device, index }) => {
  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const { t } = useTranslation("ActivityMain");
  //  = ({ device }) => {
  const {
    itemName,
    wholeYearTotal,
    companyName,
    companyType,
    hierarchyNamePath,
    gwpTotal,
    wholeYearTotalCo2EmissionIsBiomass,
  } = device;
  const category = CONST.category;
  const cat = category[emissionViewStore.selectedTab].substring(3);
  const isBiomass =
    emissionViewStore.selectedScope === "CO₂ Emission From Biomass/Bioenergy";
  return (
    <>
      <Typography>{index}</Typography>
      {/*  前端處理 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "8px",
            width: "80%",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              color: "#333",
              fontWeight: 500,
              wordBreak: "break-word",
              textAlign: "center",
            }}
          >
            {companyName || "-"}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#999",
            wordBreak: "break-word",
            textAlign: "left",
            width: "80%",
          }}
        >
          {t(hierarchyNamePath)}
        </Typography>
      </Box>

      {/* emissionViewStore裡面找 */}
      <Typography>{itemName}</Typography>
      {cat === "1_4" ? <Typography>{gwpTotal}</Typography> : null}
      <Typography>
        {isBiomass ? wholeYearTotalCo2EmissionIsBiomass : wholeYearTotal}
      </Typography>
      <Typography>
        {emissionViewStore.selectedEmissionUnitId === 21 ? "tCO₂e" : "kgCO₂e"}
      </Typography>
      {/* 寫判斷是如果數值是21顯示tCO₂e */}
    </>
  );
});

const FilesData = ({ fileData, dataTypeId }) => {
  const { t } = useTranslation("ActivityMain");
  if (!fileData?.length) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <Typography>{t("No data")}!</Typography>
      </Box>
    );
  }
  // 先對數據進行排序（從小到大）
  const sortedFiles = [...fileData].sort(
    (a, b) => parseInt(a.unit) - parseInt(b.unit),
  );
  return sortedFiles.map((file, index) => (
    <FileAccordion key={index} emission={file} dataTypeId={dataTypeId} />
  ));
};

const FileAccordion = observer(({ emission, dataTypeId }) => {
  const { t } = useTranslation("ActivityMain");
  const [expanded, setExpanded] = useState(false);
  const isBiomass =
    emissionViewStore.selectedScope === "CO₂ Emission From Biomass/Bioenergy";
  //將file.timeIndex (數字) 轉換為對應的月份
  const getMonthAbbreviation = (month) => {
    if (!month || month < 1 || month > 12) {
      return emissionViewStore.selectedYear;
    }
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[month - 1];
  };
  return (
    <Accordion onChange={() => setExpanded(!expanded)}>
      <AccordionSummary>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Stack direction="row" spacing={2}>
            {expanded ? <RemoveCircleOutlineIcon /> : <AddCircleOutlineIcon />}
            <Typography>
              {dataTypeId == 2
                ? emission.unit
                : t(getMonthAbbreviation(emission.unit))}
            </Typography>
          </Stack>

          <Typography>
            {t("Total")}:
            {isBiomass
              ? emission.totalCo2EmissionIsBiomass
              : emission.totalUnitEmission}
            {emissionViewStore.selectedEmissionUnitId === 21
              ? "tCO₂e"
              : "kgCO₂e"}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <FileDataTable
          isFossil={emission.isFossil}
          emissionList={emission.emissionList}
          dataTypeId={dataTypeId}
          isCO2e={emission.isCO2e}
        />
      </AccordionDetails>
    </Accordion>
  );
});

//FileDataTable
const FileDataTable = ({ isFossil, emissionList, dataTypeId, isCO2e }) => {
  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const { t } = useTranslation("ActivityMain");
  const category = CONST.category;
  const cat = category[emissionViewStore.selectedTab].substring(3);
  const isBiomass =
    emissionViewStore.selectedScope === "CO₂ Emission From Biomass/Bioenergy";
  let titleArr =
    cat === "2_1" || cat === "1_4"
      ? [...fileTableTitles2_1]
      : [...fileTableTitles];

  if (isCO2e) {
    const co2Index = titleArr.indexOf("CO₂");
    if (co2Index !== -1) {
      titleArr.splice(co2Index, 0, "CO₂e");
    }
  }

  // if (isBiomass) {
  //   const index = titleArr.indexOf("CO₂");
  //   if (index !== -1) {
  //     titleArr[index] = "CO₂e"; // ⭐ 直接取代
  //   }
  // }

  if (cat === "1_3" || cat === "1_4") {
    const ch4Index = titleArr.indexOf("CH₄");

    if (ch4Index !== -1) {
      titleArr[ch4Index] = isFossil ? "CH₄ fossil" : "CH₄ non-fossil";
    }
  }
  //日期格式化
  const formatDate = (dateStr, typeId) => {
    if (!dateStr) return "";

    if (typeId === 1) {
      // YYYY-MM → YYYY/MM
      return dateStr.replace("-", "/");
    }

    if (typeId === 3) {
      // YYYY-MM-DD → YYYY/MM/DD
      return dateStr.replace(/-/g, "/");
    }

    if (typeId === 4) {
      // YYYY-MM-DD_YYYY-MM-DD → YYYY/MM/DD~YYYY/MM/DD
      const [start, end] = dateStr.split("_");
      return `${start.replace(/-/g, "/")}~${end.replace(/-/g, "/")}`;
    }

    return dateStr; // 預設回傳原始字串
  };

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          {titleArr.map((title, index) => (
            <th key={index}>{t(title)}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {emissionList.map((emission, fileIndex) => (
          <tr key={fileIndex}>
            <td scope="row">
              {dataTypeId === 2
                ? emission.year
                : dataTypeId === 1 || dataTypeId === 3 || dataTypeId === 4
                  ? formatDate(emission.date, dataTypeId)
                  : null}
            </td>
            {cat === "2_1" || cat === "1_4" ? (
              <td>{emission.rawData}</td>
            ) : null}
            {isBiomass ? (
              <>
                <td>{emission.co2EmissionIsBiomass}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>

                <td>{emission.co2EmissionIsBiomass}</td>
              </>
            ) : (
              <>
                {isCO2e && <td>{emission.co2Emission}</td>}
                <td>{emission.co2Emission}</td>
                <td>{emission.ch4Emission}</td>
                <td>{emission.n2oEmission}</td>
                <td>{emission.hfcsEmission}</td>
                <td>{emission.pfcsEmission}</td>
                <td>{emission.nf3Emission}</td>
                <td>{emission.sf6Emission}</td>
                <td>{emission.totalEmission}</td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

//main
//目前假資料格式只有TimeFormat:Month
//TimeFormat:Year的內容未設計
export const Emission = observer(() => {
  const { authComArr } = emissionViewStore;
  const { t } = useTranslation("ActivityMain");
  const [expandedPanels, setExpandedPanels] = useState({});

  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const cmStore = commonStore;

  const scope = cmStore?.EACategory?.find(
    (objects) => objects.label === store.selectedScope,
  );

  ////////找出是否要渲染Action
  const hideAction = scope?.category?.find(
    (item) => item.label === store.selectedTab,
  )?.isDisabled;

  //展開
  const handleChange = (panel) => (_, isExpanded) => {
    setExpandedPanels((prev) => ({ ...prev, [panel]: isExpanded }));
  };

  ////////對應後端資料key欄位
  const [dataKey, setDataKey] = useState([]);
  const category = CONST.category;
  const cat = category[emissionViewStore.selectedTab].substring(3);

  ////////初始Emission List
  useEffect(() => {
    emissionViewStore.getEMListData({ keepPage: true });
  }, [
    emissionViewStore.selectedYear,
    emissionViewStore.authComArr,
    emissionViewStore.selectedTab,
    emissionViewStore.selectedEmissionUnitId,
    emissionViewStore.selectedEmissionGwpId,
    emissionViewStore.isRefresh,
    emissionViewStore.searchKeyword,
    emissionViewStore.selectedScope,
  ]);

  ////////初始EAList
  useEffect(() => {
    if (hideAction) return; //如果未揭漏不去呼叫API
    store.getEFListData({ keepPage: true });
  }, [
    emissionViewStore.selectedTab,
    emissionViewStore.currentCId,
    emissionViewStore.authComArr,
    emissionViewStore.selectedYear,
    emissionViewStore.isRefresh,
    emissionViewStore.searchKeyword,
  ]);

  // 初始化資料
  useEffect(() => {
    ///回傳目前使用者的category給後端
    setDataKey(
      CONST.tableTitles.find(
        (item) => item.label === emissionViewStore.selectedTab,
      ).dataKey,
    );
    ////////重置pagination的頁數為1
    emissionViewStore._handleSetPageNow(1);
  }, [emissionViewStore.selectedScope, emissionViewStore.selectedTab]);

  //判斷要使用哪title

  const accordionTitles =
    cat === "1_4" ? activityAccordionTitles1_4 : activityAccordionTitles;

  return (
    <div className={styles.container}>
      <div
        className={styles.gridContainer}
        style={{
          gridTemplateColumns:
            cat === "1_4"
              ? "0.2fr 0.3fr 1.2fr repeat(4, 1fr)" // 7 欄
              : "0.2fr 0.3fr 1.2fr repeat(3, 1fr)", // 6 欄
        }}
      >
        {accordionTitles.map((title, index) => (
          <div 
             key={index} 
             className={styles.gridItem}
          >
            {t(title)}
          </div>
        ))}
      </div>

      {/* 未揭露此活動 - 最優先判斷 */}
      {hideAction ? (
        <div className={styles.noData}>
          <p>{t("This activity has not been disclosed")}</p>
        </div>
      ) : (
        <>
          {/* 沒資料筆數 */}
          {!emissionViewStore.emissionListLoading &&
            (!emissionViewStore.EmissionCurrentPageList ||
              emissionViewStore.EmissionCurrentPageList.length === 0) && (
              <div className={styles.noData}>
                <p>{t("No data!")}</p>
              </div>
            )}
          {emissionViewStore.EmissionCurrentPageList.map((item, index) => {
            const uniqueKey = item.id;
            return (
              <ActivityAccordion
                key={uniqueKey || index}
                index={index}
                displayNumber={
                  (emissionViewStore.emissionListData.page - 1) *
                    emissionViewStore.emissionListData.pageSize +
                  index +
                  1
                }
                device={item}
                expanded={!!expandedPanels[uniqueKey]}
                // onExpand={handleChange(`panel-${index}`)}
                onExpand={handleChange(uniqueKey)}
              />
            );
          })}
        </>
      )}

      {/* <Pagination /> */}
    </div>
  );
});
